import { filtrarVendas, resumirVendas, vendasPorMes } from './vendasDoProduto'
import type { VendaDoProduto, ResumoDeVendas, BarraDoMes } from './vendasDoProduto'

// A aba Historico e ANO + SEMESTRE (roteiro dela, rodada 2, 24/09 tarde): mes
// vigente, mes anterior, "Ano de" e Personalizado sairam -- "ja tem os
// semestres, e quando clicar na barra ele ja mostra o mes". As barras sao os 6
// meses do semestre escolhido; tocar numa barra faz os numeros de cima E a
// lista mostrarem aquele mes, e a linha "periodo anterior" some (escolha dela).

export type Semestre = 1 | 2

// O ano corrente sempre; anos anteriores so se o produto vendeu neles -- sem
// isso o filtro cresceria com anos vazios.
export function anosDoHistorico(vendas: VendaDoProduto[], hoje: Date): number[] {
  const anos = new Set([hoje.getFullYear(), ...vendas.map((v) => Number(v.data.slice(0, 4)))])
  return [...anos].sort((a, b) => b - a)
}

// O Historico abre no semestre de hoje (escolha dela, 24/09 tarde).
export function semestreDe(hoje: Date): Semestre {
  return hoje.getMonth() < 6 ? 1 : 2
}

export function mesesDoSemestre(ano: number, semestre: Semestre): string[] {
  const primeiro = semestre === 1 ? 1 : 7
  return Array.from({ length: 6 }, (_, k) => `${ano}-${String(primeiro + k).padStart(2, '0')}`)
}

function limitesDoSemestre(ano: number, semestre: Semestre): { de: string; ate: string } {
  return semestre === 1 ? { de: `${ano}-01-01`, ate: `${ano}-06-30` } : { de: `${ano}-07-01`, ate: `${ano}-12-31` }
}

function semestreAnterior(ano: number, semestre: Semestre): { de: string; ate: string } {
  return semestre === 2 ? limitesDoSemestre(ano, 1) : limitesDoSemestre(ano - 1, 2)
}

export interface VisaoDoHistorico {
  barras: BarraDoMes[]
  // O mes em vigor; null quando o tocado nao e do semestre (trocou o filtro).
  mesTocado: string | null
  resumo: ResumoDeVendas
  // null com uma barra tocada: a comparacao some (escolha dela, 24/09 tarde).
  resumoAnterior: ResumoDeVendas | null
  lista: VendaDoProduto[]
}

export function visaoDoHistorico(
  vendas: VendaDoProduto[], ano: number, semestre: Semestre, mesTocado: string | null,
): VisaoDoHistorico {
  const meses = mesesDoSemestre(ano, semestre)
  const mes = mesTocado !== null && meses.includes(mesTocado) ? mesTocado : null
  const { de, ate } = limitesDoSemestre(ano, semestre)
  const lista = mes === null ? filtrarVendas(vendas, de, ate, null) : vendas.filter((v) => v.data.startsWith(mes))
  const anterior = semestreAnterior(ano, semestre)
  return {
    barras: vendasPorMes(vendas, null, meses),
    mesTocado: mes,
    resumo: resumirVendas(lista),
    resumoAnterior: mes === null ? resumirVendas(filtrarVendas(vendas, anterior.de, anterior.ate, null)) : null,
    lista,
  }
}

// "set/2026" para o aviso em cima da lista.
export function rotuloDoMes(chave: string): string {
  const [a, m] = chave.split('-').map(Number)
  const nome = new Date(a, m - 1, 1).toLocaleDateString('pt-BR', { month: 'short' }).replace('.', '')
  return `${nome}/${a}`
}
